// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const PlanTasksGridViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-plantasksgridview" */ "./PlanTasksGridView")).then((page)=>{
        return {
            default: page.PlanTasksGridView
        };
    });
export const LazyPlanTasksGridView = /*#__PURE__*/ lazy(PlanTasksGridViewLazyLoader);
